import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { NewPassword } from '@/components/auth'
import { useVerifyToken } from '@/hooks/useAuth/useVerifyToken.ts'
import { useLoading } from '@/contexts/LoadingContext'

import { ExpiredLinkPage } from './ExpiredLinkPage.tsx'

export default function ResetPasswordPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''
  const { isValid, isLoading } = useVerifyToken(token)
  const { showLoading, hideLoading } = useLoading()

  useEffect(() => {
    if (isLoading) {
      showLoading(t('auth.verifyingToken'))
    } else {
      hideLoading()
    }
  }, [isLoading, showLoading, hideLoading, t])

  if (isLoading) {
    return null
  }

  return isValid ? <NewPassword token={token} /> : <ExpiredLinkPage />
}
